import { render, staticRenderFns } from "./VendasBI.vue?vue&type=template&id=0ffe551e"
import script from "./VendasBI.vue?vue&type=script&lang=js"
export * from "./VendasBI.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports